import React from "react";
import { Video } from "./Video";
import { Image } from "./Image";
import "./preview.css";

export function Preview({ asset, onBack, preventBack, showMetadata, fullScreen, onNext, onPrev }) {
  console.log('Init asset');
  const { doctype } = asset;
  let previewEl = null;
  switch (doctype) {
    case "movie":
      previewEl = <Video asset={asset} />;
      break;
    case "image":
      previewEl = <Image asset={asset} />;
      break;
  }

  const classes = `preview-container${fullScreen ? ' full-screen' : ''}`;
  const prevClass = `nav-arrow nav-arrow-left${onPrev ? '' : ' hidden-nav'}`;
  const nextClass = `nav-arrow nav-arrow-right${onNext ? '' : ' hidden-nav'}`;

  return (
    <div className={classes}>
      <div className="preview-content"> 
        {showMetadata && asset.metadata && asset.metadata.length && (
          <div className="preview-metadata">
            {preventBack && (
              <div class="back" onClick={onBack}>
                <p>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="60"
                    height="30"
                    viewBox="0 0 512 512"
                  >
                    <title>ionicons-v5-b</title>
                    <path
                      d="M240,424V328c116.4,0,159.39,33.76,208,96,0-119.23-39.57-240-208-240V88L64,256Z"
                      style={{
                        fill: "none",
                        stroke: "#000",
                        strokeLinejoin: "round",
                        strokeWidth: "32px",
                      }}
                    />
                  </svg>
                </p>
              </div>
            )}
            <div className="meta">
              {(asset.metadata || []).map((meta) => (
                <div className="info-item">
                  <h6>{meta.label}</h6>
                  <div className="info-string">
                    {(meta.value || ["None"]).join(", ")}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
        <div className="preview-asset">
          {
            (!fullScreen) && 
            (
              <div className={prevClass}>
                <span onClick={onPrev}>
                  <svg width="3em" height="3em" viewBox="0 0 16 16" class="bi bi-chevron-left" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"/>
                  </svg>
                </span>
              </div>
            )
          }
          {previewEl || <div>Not a valid type</div>}
          {
            (!fullScreen && onNext) && 
            (
              <div className={nextClass}>
                <span onClick={onNext}>
                  <svg width="3em" height="3em" viewBox="0 0 16 16" class="bi bi-chevron-right" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                  </svg>
                </span>
              </div>
            )
          }
        </div>   
      </div>
    </div>
  );
}
